module.exports = __webpack_public_path__ + "static/media/chip-2.356d7c96.jpg";